import { Component } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-left-nav',
  imports: [CommonModule, RouterModule],
  templateUrl: './left-nav.component.html',
  styleUrl: './left-nav.component.scss'
})
export class LeftNavComponent {

  constructor(private router: Router) {}

  toggleNav() {
    const sidenav = document.getElementById('sidenav')!;
    if (sidenav.style.width === '128px') {
      sidenav.style.width = '0';
    } else {
      sidenav.style.width = '128px';
    }
  }

  loadHomeComponent(){
    this.router.navigate(['/home']);
  }

}
